import { ProjectFinancial } from './../../../models/project/ProjectFinancial.model';
import { Component, OnInit } from '@angular/core';
import { Approval } from '../../../models/Approval.model';
import { ApprovalService} from '../../../services/approval.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ConsultantService } from "../../../services/consultant.service";
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { ElegibleForDiscount } from '../../../models/ElegibleForDiscount.model';
import { AwsService } from '../../../services/aws.service';
import { StatusInvoice } from '../../../shared/enums/StatusInvoice';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { ApprovalInvoice } from '../../../models/ApprovalInvoice.model';
import { InvoiceAttachService } from '../../../services/invoice-attach.service';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { GUARDS } from '../../../shared/auth/Roles';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { AccountingPeriodBlock } from '../../../models/AccountingPeriodBlock.model';
import { AccountingPeriodBlockService } from "../../../services/accountingBlock.service";
import { isBlockPeriodInvalid } from '../../../shared/helpers/validate-block-period';
import { AccountingType } from '../../../shared/enums/AccountingBlockType';
import { StatusJustification } from "../../../shared/enums/StatusJustification";
import { Company } from '../../../models/Company.model';
import { ProjectHashtrack } from '../../../models/CompanyInventory.model';
import { CompaniesService } from '../../../services/companies.service';
import { CompanySearch } from '../../../models/CompanySearch.model';

@Component({
  selector: 'app-approvals-edit',
  templateUrl: './approvals-edit.component.html',
  styleUrls: ['./approvals-edit.component.scss'],
})
export class ApprovalEditComponent implements OnInit {
  loading: boolean;
  _id: String;
  approval: Approval = new Approval();
  approvalType:number;
  days;
  totalProjectHours = 0;
  approvedHours:number;
  descontar;
  extras;
  hourValue;
  contractTotalValue;
  totalValue;
  mensalHours;
  kind;
  honorarium;
  status;
  username;
  consultant:any;
  horasAMaisMesDescontar = 0;
  pjSelect = new Array();
  customerSelect = new Array();

  companies = new Array<Company>();
  projects: ProjectHashtrack[] = [];
  companySearch: CompanySearch = new CompanySearch();
  activeCustomers = [];
  
  dropDownProjects: any;
  projectsFin: ProjectFinancial[] = new Array<ProjectFinancial>();
  disableSave:boolean = false;
  borrowConsultant: any;
  sapDocNum: String = '';
  fileList = new Array();
  downloadUrlInvoiceAttach: string = '';
  invoiceNameForHtml: string;
  commonHelper: CommonHelper = new CommonHelper();
  invoiceStatus = new Array();
  invoiceJustification = new Array();
  isReproved: boolean;
  canEditInvoiceStatus: boolean = false;
  user: any;
  GUARDS = GUARDS;
  accountingBlock = new AccountingPeriodBlock();
  monthList;
  canSave: Boolean = true;
  allowedRoles = [GUARDS.GOVERNANCE];

  constructor(
    private ApprovalService: ApprovalService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: ToastsManager,
    private consultantService:ConsultantService,
    private projectFinancialService: ProjectFinancialService,
    private awsService: AwsService,
    private invoiceService: InvoiceAttachService,
    private errorHandler: ErrorHandlerProvider,
    private localStorage: LocalStorage,
    private accountingBlockService: AccountingPeriodBlockService,
    private companiesService: CompaniesService,
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.checkPermissions();

    const projectsAndCustomers = await this.projectFinancialService.getProjectsAndCustomers();
    this.companies = projectsAndCustomers.customers;
    this.projects = projectsAndCustomers.projects;

    this.monthList = this.commonHelper.listAllMonths();
    this.accountingBlock = (await this.accountingBlockService.getAllBlockedPeriods())
        .find(({type}: AccountingPeriodBlock) => type === AccountingType.Approval);
    this.user = this.localStorage.retrieve('user');
    this.loadInvoiceStatus();
    this._id = this.route.snapshot.params['id'];
    await this.populateProjectsAndCompanies();
    await this.getApproval(this._id);
    this.verifyStatus();
    this.validateStatusForProjects();
    this.validateStatusForProjectsCustomer();
    this.sumProjectHours(this.approval);
    this.totalValue = (this.getKind() == "PJ" && this.getHonorarium()=="Hora Aberta")?(this.totalProjectHours*this.hourValue):this.approval.consultant.contract.totalValue;
    this.updateProjectHours();
    
    if(this.approval.borrowedInvoice && this.approval.borrowedInvoice._id){
      this.borrowConsultant = await this.consultantService.getById((this.approval.borrowedInvoice._id).toString());
    }
    if(!this.approval.approvalInvoice) {
        this.approval.approvalInvoice = new ApprovalInvoice();
    }
    
    await this.getS3Files();
    this.loading = false;
  }

  async populateProjectsAndCompanies() {
    this.companySearch.limit = 99999;
    this.companySearch.active = true;
    const [projects, customers] = await Promise.all([
        this.projectFinancialService.getAllProjectsFinancial(),
        this.companiesService.searchCompanies(this.companySearch,'_id,name')
    ]);
    this.projectsFin = projects;
    this.dropDownProjects = await this.projectFinancialService.createPropertyObjDropDown(this.projectsFin, true, "Projeto", "projeto");
    this.activeCustomers = customers.map(customer => customer._id);
  }

  async populateProjects() {
    this.projectsFin = await this.projectFinancialService.getAllProjectsFinancial();
    this.dropDownProjects = await this.projectFinancialService.createPropertyObjDropDown(this.projectsFin, true, "Projeto", "projeto");
  }

  changeExcellenceCenterProjects(centerId, index){
    let selectedExcellenceCenter = this.consultant.excellenceCenter;
    this.approval.projects[index].excellenceCenter = selectedExcellenceCenter;
  }

  loadInvoiceStatus() {
    this.invoiceStatus = this.commonHelper.getStatusInvoice();
    this.invoiceJustification = this.commonHelper.getJustificationInvoice();
  };

  async refreshApprovals(approval){
    this.username = approval.consultant.fcEmail;
    let res = await this.ApprovalService.getHashtrackApprovals(this.username);
    if(res.status==200)
        this.toastr.success("Sincronizado com o Hashtrack!");
    if(res.status==401)
        this.toastr.warning("Cliente não mapeado!");
    if(res.status==400)
        this.toastr.error("Erro ao sincronizar com o Hashtrack!");
    await this.getApproval(this._id)
  }

  async getApproval(_id:String){
    this.approval = await this.ApprovalService.getApproval(_id);
    this.selectLoad();
    this.consultant = await this.consultantService.getById(this.approval.consultant._id);
    if(this.consultant)
      this.setContract(this.consultant);

    this.days = localStorage.getItem('days');
    this.setValues(this.approval);
    this.sumProjectHours(this.approval)

    if(this.approval.approvalInvoice.status == 1)
        this.canEditInvoiceStatus = true;

    this.approval.projects = this.approval.projects.map(projectApproval => {
        projectApproval.excellenceCenterList = [];
        projectApproval.excellenceCenterList = [this.consultant.excellenceCenter];
        
        if(this.approval.status == 1 && this.consultant.excellenceCenter)
            projectApproval.excellenceCenter = { _id: this.consultant.excellenceCenter._id, name: this.consultant.excellenceCenter.name };
        
        return projectApproval;
    });
  }

  checkPermissions() {
    this.user = this.localStorage.retrieve('user');
    if(!this.allowedRoles.includes(this.user.permission)) {
        this.canSave = false;
    }
  }

  setContract(consultant){
      this.approval.consultant.contract.totalValue = this.consultant.contract.totalValue;
      this.approval.consultant.contract.hourValue = this.consultant.contract.hourValue;
      this.approval.consultant.contract.mensalHours = this.consultant.contract.mensalHours;
      this.approval.consultant.contract.soldHourValue = this.consultant.contract.soldHourValue;
  }


  sumProjectHours(approval){
    let projects = approval.projects,
        total = 0;
    projects.forEach(element => {
      let hours = element.total_hours;
      total = total + hours;
    });
    this.totalProjectHours = total;
    this.approval.elegibleForDiscount = this.elegibleForDiscount();
  }

  getKind() {
    switch(this.approval.consultant.contract.kind) {
      case 1:
        return 'PJ';

      case 2:
        return 'CLT';

      case 3:
        return 'Estágio';

      case 4:
        return 'Outros';

    }
  }

  getHonorarium() {
    if(this.approval.consultant.contract.honorarium){
      switch(this.approval.consultant.contract.honorarium){
        case 1:
          return 'Hora Aberta';

        case 2:
          return 'Hora Fechada';
      }
    }else{
      return null;
    }

  }

  setValues(approval){
    if(approval.consultant.contract.mensalHours)
      this.mensalHours = approval.consultant.contract.mensalHours;

    this.hourValue = approval.consultant.contract.hourValue;

    if(approval.consultant.contract.totalValue)
      this.contractTotalValue = approval.consultant.contract.totalValue;

    this.kind = approval.consultant.contract.kind;

    if(approval.consultant.contract.honorarium)
      this.honorarium = approval.consultant.contract.honorarium;

    if(approval.approvalType)
      this.approvalType = approval.approvalType;

    this.status = approval.status;

    if(approval.extras)
        this.extras = approval.extras;

    if(approval.discounted)
        this.descontar = approval.discounted;

    this.sumProjectHours(this.approval);
    this.approval.realizedHours = this.totalProjectHours;
  }

  getDiscountedHours(){
    if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 1 && this.descontar && this.mensalHours > this.totalProjectHours){
      return (this.mensalHours-this.totalProjectHours);
    }else if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 2 && this.days && this.descontar && (this.days*8)>this.totalProjectHours){
      return (this.days*8-this.totalProjectHours);
    }else if(!this.descontar){
      return this.totalProjectHours;
    }else{
      return 0;
    }
  }

  getDiscountedValue(){
    if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 1 && this.descontar && this.mensalHours>this.totalProjectHours){
      return this.approval.consultant.contract.totalValue-(this.mensalHours-this.totalProjectHours)*this.hourValue;
    }else if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 2 && this.days && this.descontar && (this.days*8)>this.totalProjectHours){
      return this.approval.consultant.contract.totalValue - (this.days*8-this.totalProjectHours)*(this.contractTotalValue/(this.days*8));
    }else {
        this.totalValue = this.approval.consultant.contract.hourValue * this.approval.realizedHours;
        return this.totalValue;
    }
  }

  getDiscount(){
    if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 1 && this.descontar && this.mensalHours>this.totalProjectHours){
      return (this.mensalHours-this.totalProjectHours)*this.hourValue;
    }else if((this.kind >= 2 || (this.honorarium && this.honorarium == 2)) && this.approvalType == 2 && this.days && this.descontar && (this.days*8)>this.totalProjectHours){
      return (this.days*8-this.totalProjectHours)*(this.contractTotalValue/(this.days*8));
    }
  }

  async saveApproval(){
    if (this.validProjectsSelected() || (this.approval.status == 1 && this.validCustomerSelected())) {
        this.toastr.warning('Selecione um cliente/projeto para cada apontamento');
        return;
    }

    if(this.checkForExternalReferences()){
        this.toastr.warning('Cliente não vinculado ao Hashtrack');
        return;
    }

    if(!this.projectValidator()) {
        this.toastr.warning('Todos os projetos e horas da listagem devem ser preenchidas', 'Projetos incorretos');
        return;
    }

    this.sumProjectHours(this.approval);
    this.updateProjectHours();

    this.approval.status = this.status;
    this.approval.approvalType = this.approvalType;
    if(this.status == 2){
        const approvalDate = new Date(this.approval.date);
        const approvalMonth = approvalDate.getMonth() + 1;
        const approvalYear = approvalDate.getFullYear();
        const isInvalid = isBlockPeriodInvalid({
            competence: approvalMonth,
            competenceYear: approvalYear
        }, this.accountingBlock);
        if (isInvalid) {
            return this.toastr.warning(`A competência
            ${this.monthList[approvalDate.getMonth()].name.toLowerCase()}/${approvalYear} desta aprovação
                está dentro do intervalo de bloqueio. Não será possível editar esta aprovação`, 'Bloqueio Contábil', {
            toastLife:8000,
            showCloseButton: true
            });
        }
        this.sumProjectHours(this.approval);
        this.approval.realizedHours = this.totalProjectHours;
        this.totalValue = this.checkMatchHours() ?
            this.approval.consultant.contract.hourValue * (this.totalProjectHours - this.horasAMaisMesDescontar) :
            this.approval.consultant.contract.totalValue;
        this.approval.totalValue = this.descontar ? this.getDiscountedValue() :
          (this.totalValue < this.approval.consultant.contract.totalValue ? this.approval.consultant.contract.totalValue : this.totalValue);
    }

    if(this.descontar && this.status == 2){
      this.approval.discounted = true;
      this.approval.discountValue = this.getDiscount();
      this.approval.discountHours = this.getDiscountedHours();
      if(this.approvalType == 1){
        this.approval.approvedHours = this.descontar?(this.approval.consultant.contract.mensalHours.valueOf()-this.getDiscountedHours()):this.totalProjectHours;
        this.approveProjects();
      }else if(this.approvalType == 2){
        this.approval.monthCapacity = this.days*8;
        this.approval.approvedHours = this.descontar?(this.days*8-this.getDiscountedHours()):this.totalProjectHours;
        this.approveProjects();
      }
    }else if(this.approval.status == 2) {
        if(this.extras){
          this.approval.extras = true;
          if(this.approvalType == 2){
            this.approval.extrasHours = this.totalProjectHours - this.days*8;
          }else if(this.approvalType == 1){
            this.approval.extrasHours = this.totalProjectHours - this.mensalHours;
          }
          this.approval.extrasValue = this.approval.extrasHours*this.hourValue;
          this.approval.monthCapacity = this.days*8;
        }

        if(!this.extras && !this.descontar){
          this.approval.discounted = false;
          this.approval.discountHours = 0;
          this.approval.discountValue = 0;
          this.approval.extras = false;
          this.approval.extrasHours = 0;
          this.approval.extrasValue = 0;
        }

        this.approval.approvedHours = this.totalProjectHours;
        this.approveProjects();
    }else if(this.approval.status == 3){
      this.approval.approvedHours = this.approval.approvedHours;
      this.sumProjectHours(this.approval);
      this.approval.realizedHours = this.totalProjectHours;
      this.approveProjects();
    } else {
      this.approval.approvedHours = 0;
    }

    this.approval.consultant.companyName = this.consultant.contract.kind == 1 ? this.consultant.contract.companyName : '';

    this.setValueProjects();
    this.setValueProjectsCustomer();
    if(this.kind == 2 || (this.kind == 1 && this.honorarium == 2))
      this.approval.elegibleForDiscount = this.elegibleForDiscount();
    try{
      this.loading = true;
      let res = await this.ApprovalService.update(this.approval);
      this.loading = false;
      if(res && res.approval && res.approval._id){
        this.router.navigate(['/approvals']);
        this.toastr.success('Aprovação editada com sucesso!');
      } else {
        this.router.navigate(['/approvals']);
        this.errorHandler.interceptError(res, 'Aprovação');
      }
    }catch(err){
      this.loading = false;
      this.router.navigate(['/approvals']);
      this.errorHandler.interceptError(err, 'Aprovação');
    }
  }

  approveProjects(){
    this.approval.projects.map(project => {
      project.approvedHours = project.total_hours;
      project.approvedValue = (this.approval.totalValue/this.approval.realizedHours)*project.total_hours;
    });
  }

  setValueProjects() {
    for(var i=0; this.approval.projects.length > i; i++) {
        if (this.pjSelect[i].selectedItems.length > 0) {
            this.approval.projects[i].projectFinancialId = this.pjSelect[i].selectedItems[0].id;
            this.approval.projects[i].name = this.pjSelect[i].selectedItems[0].itemName;
        }
    }
  }

  setValueProjectsCustomer() {
    for(var i=0; this.approval.projects.length > i; i++) {
        if (this.customerSelect[i].selectedItems.length > 0) {
            this.approval.projects[i].customer.financialId = this.customerSelect[i].selectedItems[0].id;
            this.approval.projects[i].customer.financialName = this.customerSelect[i].selectedItems[0].itemName;
        }
    }
  }

  async selectLoad() {
    this.approval.projects.forEach(async element => {

        var objCompanyId = await this.projectsFin.find(fld => fld.hashTrack.find(fldHash => fldHash._id == element.hashTrackId ) != undefined || fld._id == element.projectFinancialId);

        if (!objCompanyId) {
            objCompanyId = new ProjectFinancial();
        }

       let projectsWithStatus = this.projectsFin.map(project => ({ ...project, name: `${project.name} ${!project.active?'(inativo)':''}` }))
        var projectsCompany = projectsWithStatus.filter(flt => flt.company._id == objCompanyId.company._id);
        var objProjectCreate = await this.projectFinancialService.createPropertyObjDropDown(projectsCompany, true, "Projeto", "projetos");
        var selectProject = objProjectCreate.dropDownList.filter(fnd => fnd.id == element.projectFinancialId);
        objProjectCreate.selectedItems = selectProject;
        objProjectCreate.dropDownSettings = {
            ...objProjectCreate.dropDownSettings,
            classes: 'dropdown-custom-financial'
        }
        this.pjSelect.push(objProjectCreate);

        let companiesWithStatus = this.companies.map(c => ({ ...c, name: `${c.name} ${!this.activeCustomers.includes(c._id)?'(inativo)':''}` }))
        var objCustomerCreate = this.projectFinancialService.createPropertyObjDropDown(companiesWithStatus,true,'Cliente','clientes');
        var selectProjectCustomer = objCustomerCreate.dropDownList.filter(customer => customer.id.toString() == element.customer.financialId.toString())
        objCustomerCreate.selectedItems = selectProjectCustomer;
        objCustomerCreate.dropDownSettings = {
            ...objCustomerCreate.dropDownSettings,
            classes: 'dropdown-custom-financial'
        }
        this.customerSelect.push(objCustomerCreate);

        if ((selectProject == undefined || selectProject.length == 0) && objCompanyId.hashTrack.findIndex(fnd => fnd.hashTrackId == element.hashTrackId) == -1) {
            var objProject = this.projectsFin.find(fld => fld.hashTrack.find(fldHash => fldHash._id == element.hashTrackId) != undefined);
            if (objProject != undefined) {
                this.toastr.onClickToast()
                  .subscribe( toast => {
                    this.router.navigate([`/projects/edit/${objProject._id}`]);
                    this.toastr.dismissToast(toast);
                  });
                this.toastr.error(`O projeto "${element.name}" está vinculado ao projeto do Financial "${objProject.name}" do cliente "${objProject.company.name}". Para vincular ao cliente correto, clique aqui!`,'Projeto vinculado ao cliente errado!',{
                  toastLife:10000,
                  showCloseButton: true
                });
            } else {
                this.toastr.onClickToast()
                .subscribe( toast => {
                  this.router.navigate(['/projects/new']);
                  this.toastr.dismissToast(toast);
                });
                this.toastr.error(`"${element.name}" não possui vínculo com um projeto do Financial. Para vincular, clique aqui!`,'Projeto não vinculado!',{
                  toastLife:10000,
                  showCloseButton: true
                });
            }
        }
    });

  }

  validProjectsSelected(): boolean {
      return this.pjSelect.find(fnd => fnd.selectedItems.length == 0);
  }

  OnCancel(){
    this.router.navigate(['/approvals']);
  }

  localStorageDays(){
    localStorage.setItem('days', this.days);
  }

  valueCheck(projectHours, totalValue){

      switch (this.approval.consultant.contract.kind) {
          case 1:
            if (this.approval.consultant.contract.honorarium == 1 && projectHours < totalValue)
                return true;
            else {
                if ((this.approval.consultant.contract.honorarium == 2) &&
                    this.checkContractDiferentHours(projectHours, totalValue))
                    return true;
                else
                    return this.hoursBiggerContract();
            }
          case 2:
            if (this.checkContractDiferentHours(projectHours, totalValue))
                return true;
            else
                return this.hoursBiggerContract();
        default:
            return false;
      }
  }

  checkContractDiferentHours(projectHours, totalValue){
    return !this.extras && (Math.abs(projectHours - totalValue)<= 1 || Math.abs(projectHours - totalValue)>= 1);
  }

  hoursBiggerContract() {
    if (this.approvalType == 2) {
        this.horasAMaisMesDescontar = (this.days * 8) - Number(this.approval.consultant.contract.mensalHours);
    }
    if (this.approvalType == 1){
        this.horasAMaisMesDescontar = 0;
    }
    return false;
  }

  checkMatchHours() {
      switch (this.approval.consultant.contract.kind) {
          case 1:
            return this.approval.consultant.contract.honorarium == 1 || (this.approval.consultant.contract.honorarium == 2 && this.extras);
          case 2:
            return this.extras;
          case 4:
            return true;
          default:
            return false;
      }
  }

  onClickExtras(){
    if(this.extras == true){
      this.approval.discountHours = 0;
      this.approval.discounted = false;
      this.approval.discountValue = 0;
    }
  }

  onClickDiscount(){
    if(this.descontar == true){
      this.approval.extras = false;
      this.approval.extrasHours = 0;
      this.approval.extrasValue = 0;
    }
  }

  elegibleForDiscount(){
    let response = new ElegibleForDiscount();

    if(this.totalProjectHours < this.mensalHours)
      response.byContract = true;
    if(this.days && (this.totalProjectHours < this.days*8))
      response.byCapacity = true

      return response;
  }

  checkElegibleForDiscount(approvalType:number, checkType:string){
    if(this.approval.elegibleForDiscount && this.approval.elegibleForDiscount[checkType] == false && this.descontar && this.approvalType == approvalType){
      return true;
    }
    return false;
  }

  checkForExtras(approvalType:number){

    if(this.extras && this.approvalType == 1){
      if(this.totalProjectHours < this.mensalHours)
        return true;
    }else if(this.extras && this.days && this.approvalType == 2){
      if(this.totalProjectHours < this.days*8){
        return true;
      }
    }
    return false;
  }

  checkForExternalReferences(){
    let response = false;
    this.approval.projects.forEach(element => {
      if(!element.customer.financialId || !element.customer.financialName)
        response = true;
    });
    return response;
  }

  distributeHours(){
    this.approval.projects.forEach(project =>{
      project.approvedValue = (this.approval.totalValue/this.approval.realizedHours)*project.total_hours;
    });
  }

  async getSapDocNum() {
    try {
        this.loading = true;
        let respSAP = await this.ApprovalService.getSapDocNumByApproval(this.approval.sapDocEntry);
        if(respSAP && respSAP.DocNum)
           this.sapDocNum = respSAP.DocNum;
        else
          this.errorHandler.interceptError(respSAP, 'Aprovação');
        this.loading = false;
    } catch(err) {
        this.errorHandler.interceptError(err, 'Aprovação');
        this.loading = false;
    }
  }

  async getS3Files(): Promise<void> {
        this.fileList = await this.awsService.getFiles(`approvals-invoices/${this.approval._id}`);
        if (this.fileList.length == 0) {
            return;
        };
        this.AwsFileUrl(this.fileList[0].Key);
    };

    async AwsFileUrl(fileKey: string): Promise<void> {
        this.downloadUrlInvoiceAttach = (await this.awsService.download(fileKey)).split('?')[0];
        this.invoiceNameForHtml = this.downloadUrlInvoiceAttach.split('/').find(url => url === 'invoice.pdf');
    };

    verifyStatus(): void {
        if(this.approval.approvalInvoice.status === StatusInvoice.Denied) {
            this.isReproved = true;
        } else {
            this.approval.approvalInvoice.justification = 0;
            this.isReproved = false;
        }
    }

    async handleNfButton(): Promise<void> {
        try {
            const timer = (time: number) => setTimeout(() => {
                this.loading = false;
            }, time);
            this.loading = true;
            const resendEmail = await this.ApprovalService.sendInvoiceRequestEmail(this.approval);
            if (resendEmail.success) {
                timer(2000);
                this.toastr.success(`Um e-mail foi enviado para o consultor solicitando o reenvio da Nota Fiscal`, 'SOLICITAÇÃO DE NOTA FISCAL');
            } else {
                this.errorHandler.interceptError(resendEmail, 'Aprovação');
                this.loading = false;
            };
        } catch (error) {
            this.errorHandler.interceptError(error, 'Aprovação');
            this.loading = false;
        }
    }

    async deleteAwsFile(): Promise<void> {
        await this.awsService.deleteFile(this.fileList[0].Key);
    };

    async approveOrReproveInvoiceAttach() {
        try {
            const operation = this.approval.approvalInvoice.status == StatusInvoice.Approved ? 'aprovada' : 'reprovada';

            if(!this.approval.hash)
                return this.toastr.error('A aprovação não possui HASH de nota fiscal. Contate o administrador', 'Erro na operação');

            if(this.approval.approvalInvoice.status == StatusInvoice.Denied) {
                if(this.approval.approvalInvoice.justification == 0)
                    return this.toastr.warning("O campo 'Justificativa' é obrigatório na reprovação de nota fiscal");
            }

            let response = await this.invoiceService.updateInvoiceAttach(this.approval);
            if(response._id) {
                this.toastr.success(`
                    A nota fiscal foi ${operation} com sucesso. Um e-mail será enviado para o ${operation == 'aprovada' ? 'consultor':'setor de governança'}`,
                    `Nota fiscal ${operation}`
                );
                this.router.navigate(['/approvals']);
            } else {
                this.errorHandler.interceptError(response, 'Nota Fiscal');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Nota Fiscal');
        }
    }

    validateStatusForProjects() {
        if (this.pjSelect.length) {
            this.pjSelect.map((select, index) => {
                this.pjSelect[index].dropDownSettings = select.dropDownSettings = {
                    ...select.dropDownSettings,
                    disabled: this.status > 1 ? true : false
                }
            });
        }
    }

    changeCustomer(index: number){
      if(!this.customerSelect[index].selectedItems.length ){
        return
      }
      const companyId = this.customerSelect[index].selectedItems[0].id
      const projects = this.projects.filter( project => project.companyId == companyId)
      const projectsFormatted = projects.map(project => ({ id: project._id, itemName: `${project.name} ${!project.active?'(inativo)':''}` }));
  
      this.pjSelect[index].selectedItems = [];
      this.pjSelect[index].dropDownList = projectsFormatted;
    }
  
    changeProject(index: number){
      if(!this.pjSelect[index].selectedItems.length ){
          return
      }
      const projectId = this.pjSelect[index].selectedItems[0].id
      const project = this.projects.find(project => project._id == projectId)
      if(project) {
          this.approval.projects[index].projectExpense = project.projectExpense
          this.approval.projects[index].excellenceCenter = this.consultant.excellenceCenter ? this.consultant.excellenceCenter : null
      }
    }
  
    validCustomerSelected(): boolean {
      return this.customerSelect.find(fnd => fnd.selectedItems.length == 0);
    }

    validateStatusForProjectsCustomer() {
      if (this.customerSelect.length) {
          this.customerSelect.map((select, index) => {
              this.customerSelect[index].dropDownSettings = select.dropDownSettings = {
                  ...select.dropDownSettings,
                  disabled: this.status > 1 ? true : false
              }
          });
      }
    }

    addProject() {
      let lastCustomerSelect = this.customerSelect.slice(-1).pop();
      let lastPjSelect = this.pjSelect.slice(-1).pop();
      let lastProjectApproval = this.approval.projects.slice(-1).pop();

      this.customerSelect.push({ ...lastCustomerSelect });
      this.pjSelect.push({ ...lastPjSelect });
      this.customerSelect[this.customerSelect.length - 1].selectedItems = [];
      this.pjSelect[this.pjSelect.length - 1].selectedItems = [];

      this.approval.projects.push({
        ...lastProjectApproval,
        total_hours: 0,
        approvedHours: 0,
        approvedValue: 0,
        excellenceCenter: null,
        hashTrackId: '',
        hashTrackName: ''
      });
    }

    removeProjectFromTable(index: number) {
      this.approval.projects.splice(index, 1);
      this.customerSelect.splice(index, 1);
      this.pjSelect.splice(index, 1);
      this.sumProjectHours(this.approval);
      this.updateProjectHours();
    }

    updateProjectHours() {
      this.approval.realizedHours = this.totalProjectHours;
      this.approveProjects();
    }

    projectValidator() {
      if(this.approval.projects.length == 0) return false;
      if(this.approval.projects.some(project => (
          (!project.projectFinancialId && !project.hashTrackId) ||
          (!project.customer || (!project.customer._id && !project.customer.financialId)) ||
          !project.total_hours
      ))) return false;
      return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/approvals-edit/approvals-edit.component.ts